import { normalizeApiError } from '../api/apiError';
import { isConcurrencyConflict } from './organizationErrors';

const MESSAGES: Record<string, string> = {
  SHIFT_NOT_FOUND: 'Shift was not found.',
  WORK_POLICY_NOT_FOUND: 'Work policy was not found.',
  VERSION_CONFLICT:
    'This record was updated by another user. Reloading the latest information.',
  ROW_VERSION_MISMATCH:
    'This record was updated by another user. Reloading the latest information.',
  RECORD_MODIFIED:
    'This record was updated by another user. Reloading the latest information.',
  CONCURRENT_UPDATE:
    'This record was updated by another user. Reloading the latest information.',
  VALIDATION_ERROR: 'Check the entered information.',
  ACCESS_DENIED: 'You do not have permission to perform this action.',
  BUSINESS_RULE_ERROR: 'The server rejected this change.',
  NETWORK_ERROR: 'Unable to connect to the server.',
  REQUEST_TIMEOUT: 'The server took too long to respond.',
};

export { isConcurrencyConflict };

export function shiftWorkPolicyErrorMessage(
  error: unknown,
  fallback = 'Unable to load shift or work policy information.',
): string {
  const code = readErrorCode(error);
  if (code && MESSAGES[code]) return MESSAGES[code];

  const apiError = normalizeApiError(error);
  if (apiError.code && MESSAGES[apiError.code]) {
    return MESSAGES[apiError.code];
  }

  // Never surface SQL, procedure names, or stack traces.
  if (
    typeof apiError.message === 'string' &&
    apiError.message.trim() &&
    !/CALL\s+sp_|SQLSTATE|stack|procedure/i.test(apiError.message)
  ) {
    return apiError.message;
  }

  return fallback;
}

function readErrorCode(error: unknown): string | null {
  if (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    typeof (error as { code?: unknown }).code === 'string'
  ) {
    return (error as { code: string }).code;
  }
  return null;
}
